<brightside-web-account-statements
  [accountId]="(currentAccountInfo$ | async)?.accountId"
  [statementType]="'monthly'"
></brightside-web-account-statements>
